export const HEROUI_CLI = 'heroui-cli';

export const TAILWINDCSS = 'tailwindcss';
export const HERO_UI = '@heroui/react';
export const HEROUI_STYLES = '@heroui/styles';
export const HEROUI_PACKAGES = [HERO_UI, HEROUI_STYLES] as const;
export const HEROUI_PREFIX = '@heroui';

export const DOCS_INSTALLED = 'https://heroui.com/docs/react/getting-started/quick-start';
